import { useLang } from '../lib/useLang'
import { RoutesEnum } from '../lib/routes'
import research from '../generated/research.json'
import './research-teaser.css'

function fmtDate(iso) {
  const [y, m, d] = iso.split('-')
  return `${d}.${m}.${y}`
}

export default function ResearchTeaser() {
  const { t } = useLang()
  const items = research.slice(0, 3)
  if (items.length === 0) return null
  return (
    <section className='hairline-bottom'>
      <div className='mx-auto max-w-6xl px-6 lg:px-10 py-20 md:py-28'>
        <div className='mb-12 md:mb-14 flex flex-wrap items-end justify-between gap-6'>
          <div className='max-w-3xl'>
            <div data-reveal className='label-eyebrow mb-8'>{t('lp.research.eyebrow')}</div>
            <h2 data-reveal className='headline-display text-3xl md:text-5xl lg:text-[3.4rem]'>{t('lp.research.title')}</h2>
            <p data-reveal className='headline-display text-xl md:text-2xl lg:text-[1.6rem] text-muted mt-3'>{t('lp.research.subtitle')}</p>
          </div>
          <a data-reveal href={RoutesEnum.RESEARCH} className='btn-ghost'>{t('lp.research.all')}</a>
        </div>
        <div className='research-grid'>
          {items.map((r, i) => (
            <a key={r.slug} href={`/research/${r.slug}/`} className='research-card' data-reveal style={{ transitionDelay: `${i * 0.1}s` }}>
              <img src={r.cover} alt='' loading='lazy' />
              <div className='research-card-body'>
                <time className='mono' dateTime={r.date}>{fmtDate(r.date)}</time>
                <h3>{r.title}</h3>
                <p>{r.description}</p>
                <span className='research-card-more'>{t('lp.research.read')}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
